import {
  type BillingProfileDomainQueryModel,
  byChargeMethod,
  ChargeMethodEnum,
  type MoneyChargeMethod,
} from '@mntn-dev/domain-types'

import { billingProfileHasAms } from './billing-profile-has-ams.ts'
import { billingProfileHasCreditCard } from './billing-profile-has-credit-card.ts'
import { billingProfileHasInvoicing } from './billing-profile-has-invoicing.ts'

export function getBillingProfileMoneyChargeMethods(
  billingProfile: BillingProfileDomainQueryModel
): Array<MoneyChargeMethod> {
  const methods: Array<MoneyChargeMethod> = []
  if (billingProfileHasAms(billingProfile)) methods.push(ChargeMethodEnum.ams)
  if (billingProfileHasInvoicing(billingProfile))
    methods.push(ChargeMethodEnum.invoice)
  if (billingProfileHasCreditCard(billingProfile))
    methods.push(ChargeMethodEnum.stripe)
  return methods.sort(byChargeMethod)
}
